import React from "react";

import * as typography from "@client/shared/typography";
import * as utils from "@client/utils";

import {SelectProgramTemplate} from "@client/components/ProgramCard";
import {Layout} from "@client/site/Layout";
import * as forms from "@client/site/forms";
import {reverse, server} from "@reactivated";

export const Template = (props: server.manager.templates.ClientRegistration) => {
    const staticURL = utils.getStaticBucketURL();
    const [selectedProgram, setSelectedProgram] = React.useState(
        (props.registration_form.fields.selected_program.widget.value ??
            null) as UUID | null,
    );

    return (
        <Layout narrow title="Register with Coach Matt">
            <form
                noValidate
                method="POST"
                action=""
                className="space-y-4"
                style={{textWrap: "pretty"}}
            >
                <forms.CSRFToken />
                <div className="flex items-center gap-4">
                    <img
                        className="inline-block size-16 rounded-full"
                        src={`${staticURL}pros/coach-matt.jpg`}
                        alt=""
                    />
                    <h1 className="text-3xl">
                        Register with{" "}
                        <span className="text-orange-500">Coach Matt</span>
                    </h1>
                </div>
                <div
                    className="
                        space-y-4
                        sm:ml-20 sm:pl-1
                    "
                >
                    <p className="text-lg">
                        Coach Matt has partnered with Joy Health Tracker to track your
                        nutrition and workouts.
                    </p>

                    <p className="text-lg">
                        When you register, Coach Matt will have full access to your
                        nutrition and workouts.
                    </p>

                    <p className="text-lg">
                        To get started, please fill out the details below.
                    </p>

                    <div className="max-w-[400px] space-y-4">
                        <forms.Fields
                            form={props.registration_form}
                            fields={["email", "full_name", "name", "invite_code"]}
                        />
                    </div>

                    <div className="flex flex-wrap gap-2">
                        <forms.Fields
                            form={props.registration_form}
                            fields={["date_of_birth", "gender", "zip_code"]}
                        />
                    </div>

                    <input
                        type="hidden"
                        name="selected_program"
                        defaultValue={selectedProgram ?? ""}
                    />
                    {props.programs.length > 0 && (
                        <div className="space-y-2 py-1">
                            <h3>Select your program</h3>
                            <SelectProgramTemplate
                                selected={selectedProgram}
                                setSelected={setSelectedProgram}
                                programs={props.programs}
                            />
                        </div>
                    )}

                    <typography.P>
                        Joy is <strong>free to use</strong> while you are managed by
                        Coach Matt.
                    </typography.P>

                    <typography.P>
                        By clicking register, you agree to our{" "}
                        <typography.A href={reverse("terms_of_service")}>
                            terms of service
                        </typography.A>
                        .
                    </typography.P>
                    <typography.Button submit>Register</typography.Button>
                </div>
            </form>
        </Layout>
    );
};
